import { MINUTE } from '@/utils/consts'
import dayjs from 'dayjs'
import { useCutOffDate } from './useCutOffDate'
import { useEffect, useState } from 'react'
import { useParsedQuery } from '@/hooks/useParsedQuery'
import { OutboundSchedulePageQueryParams } from '../types/query'

/**
 *  지난 시간대인지 체크
 *  - 1 minute interval check
 */
export const useIsExpiredCutOff = ({ date, time }: { date: string; time: string }): boolean => {
  const { parsedQs } = useParsedQuery<OutboundSchedulePageQueryParams>()

  const { cutOffDate } = useCutOffDate()

  const [isExpired, setIsExpired] = useState(isExpiredCutOff({ date, time }))

  useEffect(() => {
    const interval = setInterval(() => {
      setIsExpired(isExpiredCutOff({ date, time }))
    }, MINUTE)

    return () => clearInterval(interval)
  }, [time, cutOffDate])

  useEffect(() => {
    setIsExpired(isExpiredCutOff({ date, time }))
  }, [parsedQs.date])

  return isExpired
}

export const isExpiredCutOff = ({ date, time }: { date: string; time: string }) => {
  return dayjs().isAfter(dayjs(`${date} ${time}`))
}
